import { combineEpics } from 'redux-observable';
import { fetchUnresolvedIssues, initialRequestEpic, releaseVersionRequestEpic } from './get';
import {
	initialRequestSuccessEpic,
	releaseVersionRequestFailureEpic,
	releaseVersionRequestSuccessEpic,
} from './handlers';

export default combineEpics(
	initialRequestEpic,
	fetchUnresolvedIssues,
	initialRequestSuccessEpic,
	releaseVersionRequestEpic,
	releaseVersionRequestFailureEpic,
	releaseVersionRequestSuccessEpic,
);
